import { useInvalidateQueries } from '@partful/shared/lib/hooks/useInvalidateQueries';
import { useProductInventory } from '@partful/shared/lib/hooks/useProductInventory';
import { Job } from '@providers/job/types';
import { productInventoryEndpoints } from '@services/productInventory';
import { useMutation } from '@tanstack/react-query';

export interface UseDeleteCADJobVars {
  accountId: string;
  jobId: string;
}

export const useDeleteCADJob = () => {
  const { getService } = useProductInventory();
  const { invalidateContentProcessingJobsQueries } = useInvalidateQueries();

  return useMutation<Job, Error, UseDeleteCADJobVars>({
    mutationFn: async ({ accountId, jobId }) => {
      const productInventoryService = await getService();

      return (
        await productInventoryService.patch(
          `${productInventoryEndpoints.contentProcessing.root}/cad/${jobId}?account=${accountId}`,
          {
            status: 'DELETED',
          }
        )
      ).data.payload;
    },
    onSuccess: () => {
      invalidateContentProcessingJobsQueries();
    },
  });
};
